/**
 * Shared types for the Create-ASN wizard (CR-4888 Slice C).
 */

export interface DeliveryLineOption {
  id: number;
  delivery_number: string;
  call_off: number | null;
  call_off_reference: string;
  part_number: string;
  part_description: string;
  qty_released: string;
  /** 'warehouse' | 'direct'. CR-7142: shown as an explicit column on the
   *  line list — a direct load never reaches Saltney or Mold, and ticking one
   *  onto a warehouse ASN is the mistake the column exists to prevent. */
  delivery_option: string;
  po_order_number: string;
  po_line_number: number | null;
  /** CR-7142: the supplier's sales order. Shown beside the PO number so the
   *  warehouse knows which line to take the stock off. */
  sales_order: string;
  date_released: string;
  /** CR-7744: the customer flagged this line as a priority — pick it first. */
  is_priority?: boolean;
}

export type SourceType = 'schedules' | 'delivery_lines';

export interface ASNFormData {
  schedules: number[];
  delivery_line_ids: number[];
  courier: string;
  courier_other: string;
  tracking_number: string;
  invoice_number: string;
  method_of_transport: string;
  expected_delivery_date: string;
  /** CR-6038: user-entered total shipment weight (kg). Only collected for
   *  supplier-imported ASNs; blank for call-off / schedule sources where
   *  weight is auto-calculated from the parts master. */
  weight_kg: string;
  notes: string;
}

export const INITIAL_FORM_DATA: ASNFormData = {
  schedules: [],
  delivery_line_ids: [],
  courier: 'fedex',
  courier_other: '',
  tracking_number: '',
  invoice_number: '',
  method_of_transport: 'road',
  expected_delivery_date: '',
  weight_kg: '',
  notes: '',
};

export const WIZARD_STEPS = [
  'Source & Lines',
  'Shipment Details',
  'Review & Submit',
] as const;

export type StepIndex = 1 | 2 | 3;
